import u from "react";
import { clsx as b } from "../../../clsx/dist/clsx.js";
import { filterProps as g } from "../util/ReactUtils.js";
var P = ["points", "className", "baseLinePoints", "connectNulls"];
function l() {
  return l = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, l.apply(this, arguments);
}
function d(e, n) {
  if (e == null) return {};
  var t = O(e, n), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function O(e, n) {
  if (e == null) return {};
  var t = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (n.indexOf(r) >= 0) continue;
      t[r] = e[r];
    }
  return t;
}
function y(e) {
  return x(e) || A(e) || _(e) || j();
}
function j() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _(e, n) {
  if (e) {
    if (typeof e == "string") return h(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return h(e, n);
  }
}
function A(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function x(e) {
  if (Array.isArray(e)) return h(e);
}
function h(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
  return r;
}
var v = function(n) {
  return n && n.x === +n.x && n.y === +n.y;
}, E = function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = [[]];
  return n.forEach(function(r) {
    v(r) ? t[t.length - 1].push(r) : t[t.length - 1].length > 0 && t.push([]);
  }), v(n[0]) && t[t.length - 1].push(n[0]), t[t.length - 1].length <= 0 && (t = t.slice(0, -1)), t;
}, s = function(n, t) {
  var r = E(n);
  t && (r = [r.reduce(function(i, o) {
    return [].concat(y(i), y(o));
  }, [])]);
  var a = r.map(function(i) {
    return i.reduce(function(o, c, f) {
      return "".concat(o).concat(f === 0 ? "M" : "L").concat(c.x, ",").concat(c.y);
    }, "");
  }).join("");
  return r.length === 1 ? "".concat(a, "Z") : a;
}, S = function(n, t, r) {
  var a = s(n, r);
  return "".concat(a.slice(-1) === "Z" ? a.slice(0, -1) : a, "L").concat(s(t.reverse(), r).slice(1));
}, L = function(n) {
  var t = n.points, r = n.className, a = n.baseLinePoints, i = n.connectNulls, o = d(n, P);
  if (!t || !t.length)
    return null;
  var c = b("recharts-polygon", r);
  if (a && a.length) {
    var f = o.stroke && o.stroke !== "none", m = S(t, a, i);
    return /* @__PURE__ */ u.createElement("g", {
      className: c
    }, /* @__PURE__ */ u.createElement("path", l({}, g(o, !0), {
      fill: m.slice(-1) === "Z" ? o.fill : "none",
      stroke: "none",
      d: m
    })), f ? /* @__PURE__ */ u.createElement("path", l({}, g(o, !0), {
      fill: "none",
      d: s(t, i)
    })) : null, f ? /* @__PURE__ */ u.createElement("path", l({}, g(o, !0), {
      fill: "none",
      d: s(a, i)
    })) : null);
  }
  var p = s(t, i);
  return /* @__PURE__ */ u.createElement("path", l({}, g(o, !0), {
    fill: p.slice(-1) === "Z" ? o.fill : "none",
    className: c,
    d: p
  }));
};
export {
  L as Polygon
};
